export default __webpack_public_path__ + "report-finance.bf19b0089a1a0b5068f46272c5a08b42.svg";